import { REQUEST_SET_PROVISIONAL_CLAIMS } from 'containers/ProvisionalClaimsPage/constants';
import { fromJS } from 'immutable';

const initState = fromJS({
  provisionalClaims: [],
});

const ProvisionalClaimReducer = (state = initState, action: any) => {
  switch (action.type) {
    case REQUEST_SET_PROVISIONAL_CLAIMS:
      return state.set('provisionalClaims', fromJS(action.payload));
    default:
      return state;
  }
};
export default ProvisionalClaimReducer;
